import { GetCustomerDetail , RefuseReceiver , DealNow , AddClicks } from "@/api/CustomerInfo";
import QUERY from '@/api_app/CustomerInfo'
import { Toast } from 'vant';

const state = {
  GetCustomerDetail:{},
  RefuseReceiver:null,
  Detail: [],
  getCustomerInfo: {},
  getDataSet:{},
  getRemarkDesc:{},
};

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  },
  INIT_Detail: (state)=>{
    state['Detail'] = [];
  },
  PUS_Detail: (state, data)=>{
    state['Detail'] = state['Detail'].concat(data);
  },
  NOCLICK_forwarded: (state, data)=>{ // 同步修改转发状态
    let new_list = JSON.parse(JSON.stringify(state['Detail']))
    new_list.map((m)=>{
      if(m.msg_id == data){
        m.forwarded = 1
      }
    })
    state['Detail'] = new_list
  },
  NOCLICK_IS_REFUSE: (state, data)=>{ // 同步修改拒收状态
    let new_list = JSON.parse(JSON.stringify(state['Detail']))
    new_list.map((m)=>{
      if(m.msg_id == data){
        m.is_refuse = 1
      }
    })
    state['Detail'] = new_list
  },
  NOCLICK_IS_DEAL: (state, data)=>{ // 同步修改拒收状态
    let new_list = JSON.parse(JSON.stringify(state['Detail']))
    new_list.map((m)=>{
      if(m.msg_id == data){
        m.is_has_deal = 1
      }
    })
    state['Detail'] = new_list
  },
};

const actions = {
  GetCustomerDetail({ commit },params) {
    return new Promise((resolve)=>{
      GetCustomerDetail( params).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'GetCustomerDetail',data:newData});
          commit('PUS_Detail', newData.list)
        } catch (error) {
          console.log(error)
        }
        resolve( res.data )
      })
    })
  },
  RefuseReceiver({ commit },params) {
    return new Promise((resolve)=>{
      RefuseReceiver(params).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'RefuseReceiver',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve( res.data )
      })
    })
  },
  DealNow({ commit },params) {
    return new Promise((resolve)=>{
      DealNow(params).then(res => {
        resolve( res.data )
      })
    })
  },
  AddClicks({ commit },params) {
    return new Promise((resolve)=>{
      AddClicks(params).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          var tmp_data = state['GetCustomerDetail']
          tmp_data['clicks_yx'] = newData['clicks_yx']
          commit("SET_DATA", { key: 'GetCustomerDetail', data: tmp_data});
        } catch (error) {
          console.log(error)
        }
        resolve( res.data )
      })
    })
  },

  // APP端的接口
  getCustomerInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'getCustomerInfo', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        } else {
          commit('SET_DATA', { key: 'getCustomerInfo', data: data })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDataSet({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'getDataSet', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        } else {
          commit('SET_DATA', { key: 'getDataSet', data: data.data })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  starmarkSwitch({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'starmarkSwitch', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  blacklistSwitch({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'blacklistSwitch', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  delCustomerInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'delCustomerInfo', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getRemarkDesc({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'getRemarkDesc', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        } else {
          commit('SET_DATA', { key: 'getRemarkDesc', data: data.data })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveRemarkDesc({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'saveRemarkDesc', params }).then(response => {
        const { data } = response
        if(data.code !== 1000) {
          Toast(data.message)
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  uploadOss({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'uploadOss', params }).then(response => {
        const { data } = response
        if(data.code !== 1000) {
          Toast(data.message)
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
